import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WrapperComponent } from './wrapper.component';
export class WrapperModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [WrapperComponent],
    declarations: [WrapperComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WrapperModule_tsickle_Closure_declarations() {
/** @type {?} */
WrapperModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WrapperModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
